import getYouTubeId from 'get-youtube-id';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

const YoutubePreview = ({node}) => {
  const {url} = node;
  const id = getYouTubeId(url);
  return <LiteYouTubeEmbed id={id as string} title="YouTube Embed" />;
};

export default YoutubePreview;
